import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        ProposalId: null,
        data: {
            Proposal: null
        },
        age: null,
        riskClass: 'NonTobacco',
        products: ['AccidentExpense', 'CriticalIllness', 'HospitalIndemnity', 'DisabilityIncome','TermLife', 'WholeLife']
    },
    getters: {
        getAge: state => state.age,
        getRiskClass: state => state.riskClass,
        getProposal: state => state.data.Proposal,
        getProposalId: state => state.data.ProposalId,
        getEmployer: state => state.data.Proposal.Employer,
        getAgent: state => state.data.Proposal.Agent,
        getAccidentExpense: state => {
            if ( Array.isArray(state.data.Proposal.AccidentExpense.Plans.Plan)) {
                return state.data.Proposal.AccidentExpense.Plans.Plan.filter(plan => plan.Selected)
            } else {
                return [state.data.Proposal.AccidentExpense.Plans.Plan]
            }
        },
        getAccidentExpenseCalculator: state => state.data.Proposal.AccidentExpenseCalculator,
        getCriticalIllness: state => state.data.Proposal.CriticalIllness,
        CriticalIllnessCalculator: state => state.data.Proposal.CriticalIllnessCalculator,
        getHospitalIndemnity: state => state.data.Proposal.HospitalIndemnity,
        getHospitalIndemnityCalculator: state => state.data.Proposal.HospitalIndemnityCalculator,
        getDisabilityIncome: state => state.data.Proposal.DisabilityIncome,
        getDisabilityIncomeCalculator: state => state.data.Proposal.DisabilityIncomeCalculator,
        getTermLife: state => state.data.Proposal.TermLife,
        getWholeLife: state => (state.data.Proposal.WholeLife.Selected ? state.data.Proposal.WholeLife : state.data.Proposal.WholeLife2019.Selected ? state.data.Proposal.WholeLife2019 : null),
        getWholeLifeCalculator: state => state.data.Proposal.WholeLifeCalculator,
        getProducts: state => {
            if(!state.data.Proposal) return []
            return Object.entries(state.data.Proposal)
                .filter(([key, value]) => {
                    // determine if this object in proposal is an actual product, if not do not include in result product array
                    if (!state.products.includes(key.replace(/2019/g, ''))) return false

                    let isSelected = false
                    // handle special case for AccidentExpense which has nested Plans
                    if (key === 'AccidentExpense') {
                        if (Array.isArray(value.Plans.Plan)) {
                            isSelected = value.Plans.Plan.filter(plan => plan.Selected).length
                        } else {
                            isSelected = value.Plans.Plan.Selected
                        }
                    } else { // regular case for other products, check if the selected value is true
                        isSelected = value.Selected
                    }
                    return isSelected
                })
                .map(([key, value]) => {
                    if (key === 'AccidentExpense') {
                        if (!Array.isArray(value.Plans.Plan)) {
                            value.Plans.Plan = value.Plans.Plan.filter(plan => plan.Selected)
                        }
                    }
                    return { ...value, Id: key.replace(/2019/g, ''), Name: key.replace(/([A-Z])/g, ' $1').trim() }
                })
        }
    },
    mutations: {
        setAge: (state, value) => (state.age = value),
        setRiskClass: (state, value) => (state.riskClass = value),
        setProposal: (state, value) => (state.data = value),
        setProposalId: (state, value) => (state.ProposalId = value)
    },
    actions: {},
    modules: {}
})
